import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add-block",
  "use": "add-block-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"add-block\"><path d=\"M16.92,10.74h-4v-4a1.25,1.25,0,0,0-2.5,0v4h-4a1.25,1.25,0,0,0,0,2.5h4v4a1.25,1.25,0,0,0,2.5,0v-4h4a1.25,1.25,0,0,0,0-2.5Z\" /><path d=\"M18.42.49H11.76A11.57,11.57,0,0,0,.16,12a11.57,11.57,0,0,0,11.61,11.5h6.66L23.8,11.91ZM11.76,20.66a8.67,8.67,0,1,1,0-17.33h4.84l4.05,8.6L16.6,20.66Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol